export const ENVIRONMENTS = {
    DEVELOPMENT: 'development',
    PRODUCTION: 'production'
};

export const SORT_DIRECTIONS = {
    ASC: 'asc',
    DESC: 'desc'
};
